import { SeriesTimelineRowVariant } from '../../CalendarEvents/util/seriesTimeline';
import { SeriesOutcomeEnum } from '../../../store/series/types';
import { CalendarEventStatusENUM } from '../../../types';
import { DotColor } from '../types';

type ResolveDotColorArgs = {
  variant: SeriesTimelineRowVariant;
  isPast: boolean;
  eventStatus: CalendarEventStatusENUM;
  isCurrent: boolean;
  seriesOutcome: SeriesOutcomeEnum | undefined;
};

// Per-event color is driven by outcome + position + status:
//   completed                                                   → green
//   cancelled                                                   → yellow
//   needsOutcome + future + status===ACTIVE                     → gray
//                 (legitimately scheduled — no action needed yet)
//   needsOutcome + (past OR status!==ACTIVE)                    → purple
//                 (matches BE OUTCOME_MISSING rule — keeps dot/card and
//                  warning chip aligned)
//
// Closed-series override: the **current** dot reflects the series outcome
// (BOUGHT → dollarGreen, FAILED → red). Non-spec but ships today.
export function resolveDotColor(args: ResolveDotColorArgs): DotColor {
  const { variant, isPast, eventStatus, isCurrent, seriesOutcome } = args;

  if (isCurrent) {
    if (seriesOutcome === SeriesOutcomeEnum.BOUGHT) {
      return 'dollarGreen';
    }
    if (seriesOutcome === SeriesOutcomeEnum.FAILED) {
      return 'red';
    }
  }

  if (variant === 'completed') {
    return 'green';
  }
  if (variant === 'cancelled') {
    return 'yellow';
  }

  const isFutureActive = !isPast && eventStatus === CalendarEventStatusENUM.ACTIVE;
  return isFutureActive ? 'gray' : 'purple';
}
